var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.319,
    height: 15.319,
    viewBox: "0 0 15.319 15.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-solid",
    d: "M13.66,6a7.66,7.66,0,1,0,7.66,7.66A7.66,7.66,0,0,0,13.66,6ZM12.383,9.287a.535.535,0,1,1-.064,0Zm4.468,8.2a.638.638,0,0,1-.638.638H11.745a.638.638,0,1,1,0-1.277h1.277v-3.83h-.638a.638.638,0,0,1,0-1.277h2.553v5.106h1.277A.638.638,0,0,1,16.851,17.489Z",
    transform: "translate(-6 -6)",
    fill: "#b8c1ff",
    opacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.422b66fff4cc8b2ee3b25a33f2e0ee8d.svg";
export { ForwardRef as ReactComponent };